/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Building_Size_SqmInputs */

const en_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interior Space`)
};

const es_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio interior`)
};

const fr_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espace intérieur`)
};

const de_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innenfläche`)
};

const ja_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`室内面積`)
};

const zh_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`室内面积`)
};

const ar_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المساحة الداخلية`)
};

const id_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang Interior`)
};

const it_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spazio Interno`)
};

const ru_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутреннее пространство`)
};

const pt_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço Interno`)
};

const ko_field_building_size_sqm = /** @type {(inputs: Field_Building_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실내 면적`)
};

/**
* | output |
* | --- |
* | "Interior Space" |
*
* @param {Field_Building_Size_SqmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_building_size_sqm = /** @type {((inputs?: Field_Building_Size_SqmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Building_Size_SqmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_building_size_sqm(inputs)
	if (locale === "es") return es_field_building_size_sqm(inputs)
	if (locale === "fr") return fr_field_building_size_sqm(inputs)
	if (locale === "de") return de_field_building_size_sqm(inputs)
	if (locale === "ja") return ja_field_building_size_sqm(inputs)
	if (locale === "zh") return zh_field_building_size_sqm(inputs)
	if (locale === "ar") return ar_field_building_size_sqm(inputs)
	if (locale === "id") return id_field_building_size_sqm(inputs)
	if (locale === "it") return it_field_building_size_sqm(inputs)
	if (locale === "ru") return ru_field_building_size_sqm(inputs)
	if (locale === "pt") return pt_field_building_size_sqm(inputs)
	return ko_field_building_size_sqm(inputs)
});